import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import Swiper from '~/pages/MessagePush/compontents/MessagePanel/compontents/Swiper';
class BookingViewRC extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { urls } = this.props.context;
    return (
      <div className={css.popwrap}>
        <Swiper
          photos = {urls}
        />
      </div>
    )
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.BOOKRC_VIEW)
}))(BookingViewRC);


// WEBPACK FOOTER //
// ./src/components/Popup/BookingViewRC/index.js